type Page = {
    text: string,
    path: string,
    icon: string
}

export const navigation: Page[] = [
    {
        text: 'Load Assignments',
        path: '/load-assignments',
        icon: 'event'
    },
    {
        text: 'Logout',
        path: '/logout',
        icon: 'user'
    },
    {
        text: 'Test Barcode',
        path: '/test-barcodes',
        icon: 'event'
    }
    ,
    {
        text: 'App Debug',
        path: '/app-debug',
        icon: 'event'
    }
];
